import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, MenuItem, Row, Typography } from 'seagull';
import { ChevronRight } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useOverlayContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { BiometricLoginSheet } from './BiometricLoginSheet';
import { useBiometricLoginToggle } from './useBiometricLoginToggle';
export const GetBiometricLoginMenuItemTID = (parentTestId)=>getTestIds(parentTestId);
export const BiometricLoginMenuItem = (param)=>{
    let { testId = '' } = param;
    const { available, setupNeeded, method } = useBiometricLoginToggle();
    const { pushBottomSheetPage } = useOverlayContext();
    const { t: profileTexts } = useLocaleKeys('pages.profile');
    const { BiometricLoginMenuItemTestIds } = useMemo(()=>GetBiometricLoginMenuItemTID(testId), [
        testId
    ]);
    if (!available && !setupNeeded) {
        return null;
    }
    if (setupNeeded) {
        return /*#__PURE__*/ _jsx(MenuItem, {
            skin: "secondary",
            testId: BiometricLoginMenuItemTestIds.SetupCta(),
            onClick: ()=>pushBottomSheetPage({
                    content: /*#__PURE__*/ _jsx(BiometricLoginSheet, {})
                }),
            children: /*#__PURE__*/ _jsxs(Row, {
                width: "100%",
                gap: 12,
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        children: profileTexts.biometricSecurity.setupCtaLabel({
                            method
                        })
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        testId: BiometricLoginMenuItemTestIds.Chevron(),
                        children: /*#__PURE__*/ _jsx(ChevronRight, {})
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ _jsx(MenuItem, {
        skin: "secondary",
        testId: BiometricLoginMenuItemTestIds.Root(),
        onClick: ()=>pushBottomSheetPage({
                content: /*#__PURE__*/ _jsx(BiometricLoginSheet, {})
            }),
        children: /*#__PURE__*/ _jsxs(Row, {
            width: "100%",
            gap: 12,
            alignItems: "center",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: profileTexts.biometricSecurity.toggleLabel({
                        method
                    })
                }),
                /*#__PURE__*/ _jsx(Box, {
                    testId: BiometricLoginMenuItemTestIds.Chevron(),
                    children: /*#__PURE__*/ _jsx(ChevronRight, {})
                })
            ]
        })
    });
};
